export default {
    commander: 'commander',
    informationPersonnelle: 'INFORMATION PERSONNELLE',
    informationDelivery: 'INFORMATION DE LIVRAISON',
    paymentInformation: 'INFORMATION DE PAIEMENT',
    nextStep: 'Étape suivante',
    confirmOrder: 'Confirmer la commande',
    clientConfirm: {
        orderMade: 'Commande effectuée',
        title: 'Numéro de confirmation Boires : ',
        description: 'Merci pour votre commande. <br>Pour toute question de suivi, <br> n’hésitez pas à nous écrire à <b><a href="mailto:info@boires.ca">info@boires.ca</a></b>. <br>Santé!',
        rightTitle: 'SUIVIS DES COMMANDES',
        rightDescription: 'Le savais tu ? Tu peux faire le suivis de tes commandes et accéder à ton historique depuis la page de ton compte Boires !',
        buttonText: 'Accéder à mon compte'
    },
    guestConfirm: {
        orderMade: 'Commande effectuée',
        title: 'Numéro de confirmation Boires : ',
        description: 'Merci pour votre commande. <br>Pour toute question de suivi, <br> n’hésitez pas à nous écrire à <b><a href="mailto:info@boires.ca">info@boires.ca</a></b>. <br>Santé!',
        rightTitle: 'SIMPLIFIEZ VOS PROCHAINES COMMANDES',
        rightDescription: 'Crée ton compte pour rentrer tes informations juste une fois! Tu pourras aussi avoir accès à ton historique de commande et de livraison.',
        buttonText: 'Créer mon compte'
    },
    pickupinstore: 'Ramassage au Boutique',
    pickupinstorePlaceholder: 'Choisir un Boutique',
    produitsdelaboutique: 'Commande de Boutique',
    produitsdeagence: "Produits de l'agence",
    boutiqueProductsSubtitle: 'Produits du boutique',
    pickUp: "A ramasser uniquement",
    produitsdeagenceText: "Chercher une succursale",
    selectBranchError: "Veuillez sélectionner une branche",
    step1: 'ÉTAPE 1/3',
    step2: 'ÉTAPE 2/3',
    step3: 'ÉTAPE 3/3',
    from: {
        firstName: 'Votre prénom est obligatoire',
        lastName: 'Votre nom est obligatoire',
        email: 'Votre courriel est obligatoire',
        phone: 'Votre téléphone est obligatoire',
        password: 'Votre mot de passe est obligatoire',
    },
    noBranchFound: "Branche introuvable",
    preparingPayment: "Préparation du paiement sécurisé…",
    errorMessage1: "Erreur lors du traitement du paiement",
    errorMessage2: "Le paiement n'a pas pu être préparé. Aucun montant n'a été prélevé. Veuillez réessayer dans quelques instants ou nous écrire à info@boires.ca.",
    errorReference: "réf. {ref}",
    placeOrder: 'Passer la commande',
};
